"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketAPI = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const BaseAPI_1 = require("./BaseAPI");
class MarketAPI extends BaseAPI_1.BaseAPI {
    get executeType() {
        return ExecuteCommand;
    }
    get queryType() {
        return QueryCommand;
    }
}
exports.MarketAPI = MarketAPI;
class ExecuteCommand {
    createCollection({ contract, sender, data }) {
        return {
            label: `Create collection '${data.name}'`,
            msg: new terra_js_1.MsgExecuteContract(sender, contract, { create_collection: data }),
        };
    }
}
class QueryCommand extends BaseAPI_1.BaseQueryCommand {
}
